   /* Swiper Slider */

   const selectorsSlider = {
	arrow: "[data-slider-arrow]",
	cardImageWrapper: "[data-card-image-wrapper]"
};

const modifiersSLider = {
	initialized: "initialized"
};


class SlideshowComponentSwiper extends HTMLElement  {
    constructor(container, options) {
        super();

        this.container = this.querySelector('.swiper');

        let dataOptions = this.container.getAttribute('data');
           dataOptions = JSON.parse(dataOptions);

        this.options = {

            navigation: true,
            pagination: true,
        //   autoHeight: true,
            on: {
                afterInit: () => {
                    this.setArrowsVerticalPosition();
                    this.container.classList.add(modifiersSLider.initialized);
                },
                beforeResize: () => {
                    this.setArrowsVerticalPosition();
                },
                update: () => {
                    this.setArrowsVerticalPosition();
                }
            },
            ...dataOptions
        };

        this.init();
    }


    init() {
        if (!this.container) {
            return null;
        }

        this.cardImageWrapper =
            this.container.querySelector(selectorsSlider.cardImageWrapper) ?? null;

        this.slider = new Swiper(this.container, this.options);
    }

    setArrowsVerticalPosition() {
        if (!this.options.navigation || !this.cardImageWrapper) {
            return null;
        }

        const arrows = this.container.querySelectorAll(selectorsSlider.arrow);

        if (!arrows) {
            return null;
        }

        const position = `${this.cardImageWrapper.offsetHeight / 2}px`;

        arrows.forEach((arrow) => {
            arrow.style.top = position;
        });
    }


  }

  customElements.define('swiper-component', SlideshowComponentSwiper );




    /* Accordion */

const selectorsAccordion = {
    container: ".js-toggle-container",
    item: ".js-toggle-item",
    button: ".js-toggle-button",
    content: ".js-toggle-content"
};

const attributesAccordion = {
    accordionMode: "data-accordion-mode"
};

const modifiersAccordion = {
    active: "active"
};

const accordionModes = {
    single: "single",
    multiple: "multiple"
};


class Accordion extends HTMLElement {
    constructor() {
        super();

        const $container = $(this.querySelector(selectorsAccordion.container));
        const $button = $(this.querySelector(selectorsAccordion.button));


	if ($button.length) {

        if ($container.length) {
            $container.on("click", selectorsAccordion.button, this.toggleAccordion);
        } else {
            $button.on("click", this.toggleAccordion);
        }


	 }
   }

    toggleAccordion() {

		event.preventDefault();

        let $accordion = $(this).parent(selectorsAccordion.item);

        let $accordionContent = $accordion.find(selectorsAccordion.content);

        if (!$accordionContent) {
            return null;
        }

        let $accordionContainer = $accordion.parents(selectorsAccordion.container);

        if ($accordionContainer.length) {
            let accordionMode = $accordionContainer.attr(
                attributesAccordion.accordionMode
            );

            if (accordionMode === accordionModes.single) {
                let $openAccordions = $accordionContainer
                    .find(`${selectorsAccordion.item}.${modifiersAccordion.active}`)
                    .filter(function (index, el) {
                        return el !== $accordion[0];
                    });

                $openAccordions.removeClass(modifiersAccordion.active);

                $openAccordions
                    .find(selectorsAccordion.content)
                    .stop()
                    .slideToggle(250, function () {
                        $(this).css("height", "");
                    });

            }
        }

        $accordion.toggleClass(modifiersAccordion.active);

        $accordionContent
            .stop()
            .slideToggle(250, function () {
                $(this).css("height", "");
            });
    }


}


customElements.define('component-accordion', Accordion );



const selectorsCustomSelect = {
	select2: {
		container: "[data-custom-select]",
		dropdownHolder: "[data-custom-select-dropdown]"
	},
	choices: {
		container: "[data-custom-choices]"
	}
};

const attributesCustomSelect = {
	select2: {
		selectPlaceholder: "data-custom-select-placeholder"
	},
	choices: {
		selectPlaceholder: "data-custom-choices-placeholder"
	}
};

const modifiersCustomSelect = {
	initialized: "initialized"
};


class CustomSelect extends HTMLElement {
    constructor() {
        super();
        this.initSelects();
        document.addEventListener("select:init", this.initSelects);
    }
	initSelects() {
		let $selects = $(selectorsCustomSelect.select2.container);
		let $choices = $(selectorsCustomSelect.choices.container);

		if (!$selects.length && !$choices.length) {
			return null;
		}

		initialize($selects, initCustomSelect2);
		initialize($choices, initCustomChoices);

		function initCustomSelect2() {
			let $select = $(this);
			let placeholderValue = $select.attr(
				attributesCustomSelect.select2.selectPlaceholder
			);

			let options = {
				dropdownParent: $select.siblings(
					selectorsCustomSelect.select2.dropdownHolder
				),
				minimumResultsForSearch: -1
			};

			if (placeholderValue) {
				options.placeholder = placeholderValue;
			}

			$select.select2(options);
		}

		function initCustomChoices() {
			let select = this;
			let placeholderValue = $(select).attr(
				attributesCustomSelect.choices.selectPlaceholder
			);

			let options = {
				searchEnabled: false,
				shouldSort: false,
				itemSelectText: ""
			};

			if (placeholderValue) {
				options.placeholder = true;
				options.placeholderValue = placeholderValue;
			}

			new Choices(select, options);
		}


        function initialize(containers, callback) {
            Array.from(containers)
                .filter(function (element) {
                    return !element.classList.contains(modifiersCustomSelect.initialized);
                })
                .forEach(function (element) {
                    callback.call(element);

                    element.classList.add(modifiersCustomSelect.initialized);
                });
        }
  }

}

customElements.define('custom-select', CustomSelect );






const selectors2 = {
	wrapper: "[data-quantity-selector]",
	input: "[data-quantity-selector-input]",
	increment: "[data-quantity-selector-increment]",
	decrement: "[data-quantity-selector-decrement]"
};


class QuantitySelector extends HTMLElement {
    constructor() {
        super();

        const quantitySelectors = this.querySelectorAll(selectors2.wrapper);
        quantitySelectors.forEach((quantitySelector) =>
		this.initQuantitySelector(quantitySelector)
	    );
    }

     initQuantitySelector(quantitySelector) {
		quantitySelector.addEventListener("click", this.onQuantityChange);
	}

    onQuantityChange(event) {

		const input = this.querySelector(selectors2.input);

		if (!input) {
			return null;
		}

		const target = event.target;
		const isIncrement = target.closest(selectors2.increment);
		const isDecrement = target.closest(selectors2.decrement);

		if (!isIncrement && !isDecrement) {
			return null;
		}

		const changeValue = isIncrement ? 1 : -1;

		const valueBefore = + input.value;
		const valueAfter = valueBefore + changeValue;

		const canIncrement = isIncrement && valueAfter <= input.max;
		const canDecrement = isDecrement && valueAfter >= input.min;

		if (canIncrement || canDecrement) {
			input.value = valueAfter;
		}

	}

}
customElements.define('quantity-selector', QuantitySelector );




class returnPreviousPage extends HTMLElement {
    constructor() {
        super();

        const backBtn = this.querySelector(".back-previous-js");
        backBtn.addEventListener("click", returnPreviousPage);
        function returnPreviousPage(){
        history.go(-1);
        };
    }

}
customElements.define('returen-previous-page', returnPreviousPage );





class readMoreByHeight {
	constructor(parentElement,childText) {
		   this.defaultMinusHeight = 140;
		   this.parentElement = document.querySelector(parentElement);
		   this.childText = document.querySelector(childText);
		   this.button = null;
		   this.crop = 1;
		   // this.defaultHeight = 360

		this.init();

	}

	init() {

		if (window.screen.width <= 900) {
			this.childGetHeightElement = document.querySelector('[data-get-height-for-text-m]')?.querySelector('.collection-banner__column');
		}
		else {
			this.childGetHeightElement = document.querySelector('[data-get-height-for-text-d]')?.querySelector('.collection-banner__column');
		}

		if (!this.childGetHeightElement) {
			this.childGetHeightElement = document.querySelector('[data-get-height-for-text-d]');
		}

		if (!this.childText) {
			return
		}

		this.childText.style.opacity = '1';

		if (!this.parentElement || !this.childGetHeightElement) {
			return null;
		}

		this.createButtonReadMore();

		this.fullHeigth = this.parentElement.clientHeight;
		this.textHeight = this.childText.clientHeight + 65;
		this.imagesHeight = this.childGetHeightElement.clientHeight;
		this.crop = this.textHeight - this.imagesHeight;

		if ((this.textHeight) > this.imagesHeight) {
			this.cropText();
			this.addReadMoreButton();
			this.button.addEventListener('click', this.showText.bind(this));
		} else {
			this.childText.style.opacity = '1';
		}
	}

	cropText() {
		this.childText.style.height = this.textHeight - this.crop - this.defaultMinusHeight + 'px';
		this.childText.style.overflow = 'hidden';
		this.childText.style.opacity = '1';
	}

	createButtonReadMore() {
		let a = document.createElement('a');
		let link = document.createTextNode("Read more");
		a.appendChild(link);
		a.href = "#";
		a.classList.add('collection-banner__description--readmore')
		this.button = a;
	}

	addReadMoreButton() {
		if (this.button)
		this.childText.appendChild(this.button);
	}

	showText(e) {
		e.preventDefault();
		this.button.classList.add('hidden');
		this.parentElement.style.overflow = 'visible';
		this.parentElement.style.maxHeight = 'initial';
		this.childText.style.height = 'auto';
		this.childText.style.overflow = 'visible';

	}

}

new readMoreByHeight('[data-collection-banner]','[data-height-read-more]')



   class Tooltip {
	   constructor(container) {
		   if (!container) {
			   return null;
		   }

		   const content = container.dataset.tooltipContent ?? "";

		   tippy(container, {
			   content: content,
			   placement: 'bottom',
			   arrow: true,
			   allowHTML: true,
			   maxWidth: 300,
			   animation: "shift-away"
		   });
	   }
   }

   (function () {
	   const selectors = {
		   tooltip: "[data-tooltip]"
	   };

	   const tooltips = document.querySelectorAll(selectors.tooltip);
	   if (!tooltips.length) {
		   return null;
	   }

	   tooltips.forEach((tooltip) => {
		   return new Tooltip(tooltip);
	   });
   })();

$('.list-link a').on('click', function(e) {
				
				e.preventDefault(); // prevent hard jump, the default behavior
				var target = $(this).attr("href"); // Set the target as variable
				console.log(target);
		
				$('html, body').stop().animate({
						scrollTop: $(target).offset().top - 100
				}, 600, function() {
						//location.hash = target; //attach the hash (#jumptarget) to the pageurl
						console.log($(target).offset().top);
				});

				return false;				
		});	



  var swiper = new Swiper(".similar-pro-slide", {
      slidesPerView: 3,
      spaceBetween: 30,
     pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="page-n ' + className + '">' + (index + 1) + "</span>";
        },
      },
      breakpoints: {
        "@0.00": {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        "@0.75": {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        "@1.00": {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        "@1.50": {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });

  var swiper = new Swiper(".img-slide", {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });


$(document).ready(function(){
 
    $('.product__accordion > .js-toggle-item').click(function() {
      if ($(this).hasClass("active")) {
       $(this).removeClass("active").find(".js-toggle-content").slideUp();
      } else {
      $(".product__accordion > .js-toggle-item.active .js-toggle-content").slideUp();
      $(".product__accordion > .js-toggle-item.active").removeClass("active");
      $(this).addClass("active").find(".js-toggle-content").slideDown();
      }
      return false;
    });

    
    });